import ApiService from '@/services/ApiService';

export default {
  newDelivery(stocks) {
    return ApiService().put('/stock/update', stocks);
  },
  getAll() {
    return ApiService().get('/stock/list');
  },
};
